import React from 'react';
const Checkmark = ({ width, height }) => {
    return (React.createElement("svg", { width: width || '24', height: height || '24', viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: "12", cy: "12", r: "11.5", fill: "#34C54F", stroke: "#34C54F" }),
        React.createElement("path", { d: "M6 14.2727L9.69231 17L13.8462 12L18 7", stroke: "white", strokeWidth: "1.71429", strokeLinecap: "round" })));
};
export default Checkmark;
